import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";

// Screens
import Today from "../screens/Today";
import Discover from "../screens//Discover";
import Profile from "../screens//Profile";
import TabBar from "../components/common/TabBar";

const Tab = createBottomTabNavigator();

const TabNavigator = () => (
  <Tab.Navigator
    // initialRouteName="Profile"
    tabBar={({ state, navigation }) => (
      <TabBar state={state} navigation={navigation} />
    )}
    screenOptions={({ route }) => ({
      headerShown: false,
    })}
  >
    <Tab.Screen name="Today" component={Today} />
    <Tab.Screen name="Discover" component={Discover} />
    <Tab.Screen name="Profile" component={Profile} />
  </Tab.Navigator>
);

export default TabNavigator;
